import { logOut, updateLocalStorageToken } from "../../../../containers/resources/utils";
import CabinService from "../../../../services/catalogs/CabinService";

export const REQUEST_CREATE_CABIN = "REQUEST_CREATE_CABIN";
export const CREATE_CABIN_SUCCESS = "CREATE_CABIN_SUCCESS";
export const CREATE_CABIN_ERROR = "CREATE_CABIN_ERROR";

function requestCreateCabin() {
  return {
    type: REQUEST_CREATE_CABIN,
  };
}

function createCabinSuccess(json) {
  return {
    type: CREATE_CABIN_SUCCESS,
    message: json.data,
  };
}

function createCabinError(json) {
  return {
    type: CREATE_CABIN_ERROR,
    error: json.data,
  };
}

export function createCabin(yacht_id, cabin) {
  return (dispatch) => {
    dispatch(requestCreateCabin());
    return CabinService.postCabin(yacht_id, cabin).then((json) => {
      if (json.data.code === 200) {
        dispatch(createCabinSuccess(json.data));
      } else if (json.data.code === 202) {
        updateLocalStorageToken(json.data.token);
        dispatch(createCabin(yacht_id, cabin));
      } else if (json.data.code === 498) {
        logOut();
      } else {
        dispatch(createCabinError(json.data));
      }
    });
  };
}
